// /home/clement/compta-app/client/src/components/Notifications/PreferencesNotifications.js

import React, { useState } from "react";

const PreferencesNotifications = () => {
    // État pour stocker les préférences de notification
    const [preferences, setPreferences] = useState({
        email: false,
        sms: false,
        push: false,
        son: true,
    });

    // Fonction pour gérer les changements dans les préférences
    const handleChange = (e) => {
        const { name, checked } = e.target;
        setPreferences(prevPreferences => ({
            ...prevPreferences,
            [name]: checked,
        }));
    };

    // Fonction pour sauvegarder les préférences (simulée ici)
    const savePreferences = () => {
        console.log("Préférences sauvegardées :", preferences);
        // Ici, vous pourriez envoyer les préférences au backend
        // Exemple : fetch('/api/notifications/preferences', { method: 'POST', body: JSON.stringify(preferences) });
    };

    return (
        <div className="preferences-notifications">
            <h2>Préférences de Notification</h2>
            <form>
                <label>
                    <input
                        type="checkbox"
                        name="email"
                        checked={preferences.email}
                        onChange={handleChange}
                    />
                    Recevoir des notifications par e-mail
                </label>
                <br />
                <label>
                    <input
                        type="checkbox"
                        name="sms"
                        checked={preferences.sms}
                        onChange={handleChange}
                    />
                    Recevoir des notifications par SMS
                </label>
                <br />
                <label>
                    <input
                        type="checkbox"
                        name="push"
                        checked={preferences.push}
                        onChange={handleChange}
                    />
                    Recevoir des notifications push
                </label>
                <br />
                <label>
                    <input
                        type="checkbox"
                        name="son"
                        checked={preferences.son}
                        onChange={handleChange}
                    />
                    Activer les sons de notification
                </label>
                <br />
                <button type="button" onClick={savePreferences}>
                    Sauvegarder
                </button>
            </form>
        </div>
    );
};

export default PreferencesNotifications;
